var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgContactimg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 275.8 228.7",
    style: {
      enableBackground: "new 0 0 275.8 228.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#747B87;stroke-width:0.7327;stroke-linecap:round;stroke-linejoin:round;}\r\n\t.st1{fill:#FFFFFF;stroke:#747B87;stroke-width:0.7327;stroke-linecap:round;stroke-linejoin:round;}\r\n\t.st2{fill:#4B5360;stroke:#747B87;stroke-width:0.7327;stroke-linecap:round;stroke-linejoin:round;}\r\n\t.st3{fill:none;stroke:#747B87;stroke-width:1.4653;stroke-linecap:round;stroke-linejoin:round;}\r\n\t.st4{fill:#FFFFFF;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M231.6,227.7v-98.8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M223.5,227.7v-49"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M234.1,145c0,0-8.1-0.9-11.4-7.3s-3.6-22.9,8.9-41.2c12.6-18.3,19.2-18.5,21.4-3.6c2.2,14.9,1.9,36.6-3.3,44.8 C244.6,146,234.1,145,234.1,145z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M236.9,110.6c1.5-5.1,3.3-9.6,5.3-12.8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M230.7,143.9c1.1-10.1,2.9-20,5.3-29.9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M238.9,177.1c0,0-5.2-4-4.8-9.8c0.4-5.8,7.1-17.3,23.4-24.6c16.3-7.3,20.9-4.7,16.2,6.5 c-4.7,11.2-14,26-21,29.5C245.7,182.2,238.9,177.1,238.9,177.1z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M255.3,154.6c3.2-2.9,6.3-5.3,9-6.6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M253.2,156.5c-5.8,5.8-11.2,11.9-16.1,18.4c0,0-4.2,5.6-5.4,16.8"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M235.9,210.5c0,0-3-2.3-2.8-5.7c0.2-3.3,4.1-10,13.5-14.3c9.4-4.2,12.1-2.7,9.4,3.8 c-2.7,6.5-8.1,15.1-12.2,17.1C239.9,213.4,235.9,210.5,235.9,210.5z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M245.4,197.5c1.6-1.5,3.3-2.8,5.3-3.8"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M244.2,198.6c-3.3,3.3-6.5,6.9-9.3,10.6c0,0-2.4,3.3-3.1,9.7"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M224.2,163.7c0,0,5.2-4,4.8-9.8c-0.4-5.8-7.1-17.3-23.4-24.6c-16.3-7.3-20.9-4.7-16.2,6.5s14,26,21,29.5 C217.4,168.8,224.2,163.7,224.2,163.7z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M207.9,141.2c-2.7-2.6-5.7-4.8-9-6.6"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M209.9,143.2c5.8,5.8,11.1,11.9,16.1,18.4c0,0,4.2,5.6,5.4,16.8"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M221.7,208.4c0,0,5.3,0.2,7.9-3c2.6-3.2,4.2-12-2.4-22.8c-6.6-10.8-10.8-11.5-13.4-3.7 c-2.6,7.9-4.2,19.4-1.5,24.3S221.7,208.4,221.7,208.4z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M222.5,200.3c0.1,1.1,0.1,2.2,0.2,3.2"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M218.5,178.4c1.8,6.3,3.1,12.8,3.8,19.4"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M150.7,137.9h46.9c0,0-25.4,62.5-20.6,90.4h-47.5C129.5,228.3,138.3,157,150.7,137.9z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M110.1,48.3c0,0,0.5,8.5,16.2,13.4c15.7,4.9,31.7,0,40.6,7c8.9,7,8.7,17.9,5.6,23.3c-3.1,5.4-8,10.8,6.6,17.1 c14.6,6.3,5.9,24.9-0.2,31.7c-6.1,6.8-16.6,10.1-28.4,7.8c-11.8-2.3-25.6-30.8-40.6-45.8C94.8,87.7,93,60,102.6,52 C112.2,44,110.1,48.3,110.1,48.3z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M107.7,17.9c0,0,6.5-2.8,8.1,2.6S118,41,118,41l-3.5-0.8c0,0,0.8-17-3-19.6c-3.8-2.7-6.8,3.3-6.8,3.3 L107.7,17.9z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M34.9,200.3l22.1-11.8c0,0-1.5-23.2-1.3-24.1c0.2-0.9,5.8-46.3,5.8-46.3l-15.2,45L34.9,200.3z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M132.8,94.7c0,0,21.9,11.9,24.8,13.1c2.9,1.2,1.2,16.4,1.2,26.4S144,228.1,144,228.1H33.7 c0,0,18.6-28.6,19.1-36c0.5-7.5-2.7-13.4-3.2-20.6c-0.5-7.2,10.2-51.2,11.9-53.4c1.7-2.3,9.2-7.9,9.2-7.9L97.1,87l12.2-2.7 L132.8,94.7z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M59.7,200.1l-3.7,7.6"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M63.3,178.4c0,0-5.5,3.7-2.7,5.7c2.7,2,4,6.2,4,6.2l-3.5,6.8"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M89,196.5c1.5,0.1,3,0.2,4.7,0.2"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M65.5,190.3c0,0,5.9,4,18.9,5.7"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M50.7,31.5c-1,0.5-1.9,1.3-2.5,2.3c-0.6,1-0.9,2.2-0.8,3.3c0,4.3,3.5,12.8,3.5,12.8l2-0.7c0,0-3.7-8.8-3.2-12 c0.2-0.9,0.6-1.8,1.2-2.5c0.6-0.7,1.4-1.2,2.3-1.5l-0.7-2.2L50.7,31.5z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M59.2,53.8c0.9,4.4-0.6,8.3-3.3,8.8c-2.7,0.5-5.5-2.6-6.3-7c-0.8-4.4,0.6-8.3,3.3-8.8 C55.6,46.3,58.4,49.4,59.2,53.8z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M67.3,52.4C69,57.9,67,63.5,63,64.6c-4,1.2-8.7-2.4-10.3-7.9C51,51.1,52.9,45.6,57,44.4 C61,43.3,65.7,46.8,67.3,52.4z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M82.3,82.8l3.9,12.8l-12.9,16.3l-2.2,12.6c0,0-2.1,35.9-0.9,41.4c1.2,5.5,1.2,7.1,1.2,7.1s26.7-31,39.9-50 c13.2-19,16.3-30.7,16.3-30.7l-12.9-7l-6.1-28.6L82.3,82.8z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M102.7,70.4L86.3,95.6l-4.6-14.8L102.7,70.4z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M71.3,123.8l-0.1,0.7c0,0-2.1,35.9-0.9,41.4c1.2,5.5,1.2,7.1,1.2,7.1s26.7-31,39.9-50c1-1.5,2-2.9,2.9-4.3 C97.8,124.3,80.9,124.4,71.3,123.8z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M64.8,4.4c0,0-12.3,7.5-13.6,18.8c-1.3,11.3,3.3,23.4,5.2,28.3c1.8,4.8,8.1,23.6,11.5,27.3 c3.3,3.7,14.1,9.1,16,10.1c1.8,1,5.1,0.7,8-1.3s14.5-16.1,16.3-19.4c1.8-3.3,2.2-10.6,2.2-10.6s-0.3-14.6-1-24.1 c-0.7-9.5-0.2-18.6-8-26.6C93.4-1.2,72.5-1.4,64.8,4.4z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M109.2,33.3c-0.7-9.5-0.2-18.6-8-26.6c-7.8-8-28.8-8.1-36.4-2.3c0,0-12.3,7.5-13.6,18.8 c-0.8,6.6,0.5,13.4,2,18.9C56,40.4,65.6,34.5,76.3,27c12.8-9,17-22.9,17-22.9s1.5-0.8,1.2,1c-0.3,1.8-5.3,12.6-7.1,14.3L85.4,21 c0,0,1.5-0.3,8.3,7.8c6.8,8.1,10.6,11.5,12.6,12.5c1.1,0.4,2.2,0.6,3.3,0.6C109.5,39,109.4,36,109.2,33.3z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M88.7,51c0.2,1.2-0.2,2.3-1,2.5c-0.8,0.1-1.6-0.7-1.8-2c-0.2-1.2,0.2-2.3,1-2.5C87.7,48.9,88.5,49.8,88.7,51z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M70.1,53.6c0.2,1.2-0.2,2.3-1,2.5c-0.8,0.1-1.6-0.7-1.8-2c-0.2-1.2,0.2-2.3,1-2.5 C69.1,51.5,69.9,52.4,70.1,53.6z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M81.1,43.5c0,0,5.5-4.3,10.5-0.8"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M70,45.8c0,0-6.5-3.2-11,2.5"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M72.9,46.3c0,0,3.8,3.2,3.1,7.3"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M76.1,63.8c0,0,1.8,1.3,5,0.3"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M74.8,70.7c3.7-0.2,7.4-1,10.8-2.5c5.8-2.5,8.1-6,8.1-6"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M77.6,70.6c1.3,1.2,4.1,0.9,6.4,0c2.1-0.8,4-3.5,4-3.5S80.4,70.4,77.6,70.6z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M112.2,58.3c4.2,0,7.6-4.7,7.6-10.6s-3.4-10.6-7.6-10.6s-7.6,4.7-7.6,10.6S108,58.3,112.2,58.3z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M115.4,54c2.7,0,4.9-3.6,4.9-8.1c0-4.5-2.2-8.1-4.9-8.1c-2.7,0-4.9,3.6-4.9,8.1C110.5,50.3,112.7,54,115.4,54z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M56,59c0,0,0.1,17.3,4.5,18.8c4.5,1.5,16.8-1.5,16.8-1.5"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M83.6,76.2c0,1.3-1.6,2.4-3.7,2.4c-2,0-3.7-1.1-3.7-2.4c0-1.3,1.6-2.4,3.7-2.4S83.6,74.8,83.6,76.2z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M84.6,96.4c0,0-5.3,9.2-8.9,36.5c-3.7,27.3-1.2,32.8-1.2,32.8l-5.3,3.2c0,0-10.9-1.2-7.2-27.1 c3.7-25.8,5.8-30.1,5.8-30.1L84.6,96.4z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M117.9,87c0,0-11.9,28.3-24.3,46c-12.4,17.6-29.3,42.9-29.3,42.9s8.9-4.2,27.8-18.4c18.9-14.2,38-46.7,40-49.9 c2-3.2,5-10.7,5-10.7L117.9,87z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M14.7,212.8c-2.9,1.8-6,3.3-9.1,4.6c-5.6,2.3-6.1,1.9-4.3,3.8c1.8,1.9,11.2-1.5,13.7-2.5c2.5-1,7.4-2.5,7.4-2.5 s5.8,3.3,9.4,4.3c3.6,1,7.9-0.5,7.9-0.5s0.3-4.1-2.8-6.3c-3-2.3-9.6-7.6-11.9-7.4C22.6,206.5,14.7,212.8,14.7,212.8z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M13.2,206.7c0,0-3-0.8-5.1,0.8c-2,1.5-4.3,6.4-4.6,7.6c-0.3,1.3,0.3,2,2.3,0.3s5.6-4.3,5.6-4.3l3-1L13.2,206.7z "
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M21.1,204.4c0,0-6.1-2-7.4-0.3c-1.2,1.8-5.6,11.9-4.3,12.7c1.3,0.8,3-0.8,5.3-4.1c2.3-3.3,3.6-5.1,3.6-5.1 l3-0.5L21.1,204.4z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M32,206.7c0,0-7.9-6.2-9.9-4.7c-2,1.5-8.4,11.2-9.2,13.1c-0.7,2,2.7,1,5.5-1.5c2.7-2.5,6-5.3,6-5.3l6.2,3.2 L32,206.7z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M60.5,211.4c0,0-10.4-0.5-14.7-2s-12.7-4.7-15.2-4.5c-2.5,0.2-11.9,9.4-13.9,11.4c-2,2-1.8,2.5,0.2,2.8 c2,0.2,6.8-3,9-4.8c1.4-1.1,2.9-2,4.5-2.7c1.8,2.6,3.8,5,6,7.2c2.5,2.2,8.4,4,10.7,3.7c1.4-0.2,2.8-0.4,4.2-0.7l8.5-0.2L60.5,211.4z "
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M133.1,139.6c0,0-9.2,10.7-8.7,14.4c0.5,3.7,0.7,7.4,0.7,7.4l-6.7,40.5c0,0-5.7-2.7-5.7-0.5v2.2L59,209.2 l-0.5,18.9l85.4,0.2c0,0,4.2-4.7,4.7-6.5c0.5-1.7,9.9-31.8,12.4-63.3c2.5-31.5,1.2-45.7,0-48.2c-1.2-2.5-15.9-7.2-15.9-7.2"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M133.1,139.6c0,0-9.2,10.7-8.7,14.4c0.5,3.7,0.7,7.4,0.7,7.4l-6.7,40.5c0,0-5.7-2.7-5.7-0.5v2.2L59,209.2 l-0.5,18.9l85.4,0.2c0,0,4.2-4.7,4.7-6.5c0.5-1.7,9.9-31.8,12.4-63.3c2.5-31.5,1.2-45.7,0-48.2c-1.2-2.5-15.9-7.2-15.9-7.2"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M120.4,201.7c0,0,7.9,5.2,12.7,6.5L120.4,201.7z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M120.4,201.7c0,0,7.9,5.2,12.7,6.5"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M45.9,151.3l6.1-19.7c2.5-2.4,4.7-5.2,6.5-8.1c2.6-4.4,2.6-12.8,2.2-14.3c-0.4-1.5,5.4-8.1,7-10.5 c1.6-2.4,2.6-6.7,0.4-9.8s-3.3,2-4.8,4.4c-1.5,2.4-6.7,4.8-6.7,4.8l-5.5,4.4c0,0-9.1,8-9.6,9.1c-0.6,1.1-1.7,4.6-1.7,4.6l0.7,10.7 l-4.8,18.7L45.9,151.3z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M47.4,96.2c0,0,4.4-7,5.7-9.2c1.3-2.2,3.3-11.1,4.6-10.5c1.3,0.6,2.6,3.5,2.2,7.4c-0.4,3.9-5,12.8-5,12.8 L47.4,96.2z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M36.7,140.2l3.9-13.1L38.9,106l5.2-10l14.2-1.8c0,0,8.7,4.6,9.4,4.6c0.7,0,0,2-1.7,2.4 c-1.7,0.4-4.8-0.6-4.8-0.6l5.4,3.5c0,0-0.4,1.7-1.7,2c-1.3,0.3-2.6,0.4-3.9,0.4c0,0,4.6,3,3.5,3.5c-1.1,0.5-2.3,0.8-3.5,0.7h-3.5 l-2.8-0.4l-4.3,1.7c0,0,3,7.6,2.8,11.3c-0.2,3.7-4.8,6.1-4.8,6.1"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M36.7,140.2l3.9-13.1L38.9,106l5.2-10l14.2-1.8c0,0,8.7,4.6,9.4,4.6c0.7,0,0,2-1.7,2.4 c-1.7,0.4-4.8-0.6-4.8-0.6l5.4,3.5c0,0-0.4,1.7-1.7,2c-1.3,0.3-2.6,0.4-3.9,0.4c0,0,4.6,3,3.5,3.5c-1.1,0.5-2.3,0.8-3.5,0.7h-3.5 l-2.8-0.4l-4.3,1.7c0,0,3,7.6,2.8,11.3c-0.2,3.7-4.8,6.1-4.8,6.1"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M61.3,100.6c0,0-3-2.4-4.6-2.4c-1.7,0-11.8,1.8-11.8,1.8"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M61.1,106.5c0,0-4.8-2.6-6.3-2.6s-13.1,3-13.1,3"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M36.9,136.1l15,10.1c0,0-6.7,35.9-7.3,39c-0.7,3.1-5.5,11.2-7.9,13.6c-2.4,2.4-5.3,2-11.8,0.2 s-12.3-7-12.1-13.8C13,178.4,36.9,136.1,36.9,136.1z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactimg);
export default __webpack_public_path__ + "static/media/contactimg.7df907dff3cab9ae5bdd4a5c11a1cdf1.svg";
export { ForwardRef as ReactComponent };